import { SEARCH_BAR_Z_INDEX } from '../../../constants/z-index';

const IOS_SOFT_KEYBOARD_HEIGHT = 346;
const IOS_SOFT_KEYBOARD_QUICK_TYPE_HEIGHT = 20;

interface GetListStylesPropsParams {
  hasExtraPadding: boolean;
  timeout: number;
  isBodyOverlayVisible: boolean;
  open: boolean;
  isSingleColumn: boolean;
}

const getWidthStyle = (isSingleColumn: boolean) =>
  isSingleColumn
    ? { minWidth: [null, '320px', null, null] }
    : { minWidth: [null, '320px', '817px', '995px'] };

const getListStyles = ({
  hasExtraPadding,
  timeout,
  isBodyOverlayVisible,
  open,
  isSingleColumn,
}: GetListStylesPropsParams) => ({
  ...getWidthStyle(isSingleColumn),
  borderTopStyle: ['solid', 'none'],
  borderTopWidth: ['small', 'none'],
  borderTopColor: ['sys.neutral.border.weak', 'none'],
  p: ['sp_8', 'sp_16'],
  display: open ? 'flex' : 'none',
  opacity: open ? 1 : 0,
  transitionTimingFunction: open ? 'ease-out' : 'ease-in',
  pb: hasExtraPadding ? IOS_SOFT_KEYBOARD_HEIGHT + IOS_SOFT_KEYBOARD_QUICK_TYPE_HEIGHT : 'sp_8',
  transition: `${timeout}ms`,
  ...(isBodyOverlayVisible && { zIndex: SEARCH_BAR_Z_INDEX }),
});

export default getListStyles;
